import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import ChinaToursPage from '../components/ChinaToursPage';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

const PageContainer = styled.div`
  background-color: #efefef;
  min-height: 100vh;
`;

const TitleSection = styled.div`
  background-color: #ededed;
  padding: 29px 0;
  
  @media (max-width: 479px) {
    padding: 26px 0;
  }
`;

const TitleContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const MainTitle = styled.h1`
  color: #343434;
  font-size: 42px;
  font-family: 'Geologica', Arial, sans-serif;
  font-weight: 700;
  
  @media (max-width: 479px) {
    font-size: 25px;
  }
`;

const ChinaTours = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": "Максимум Тур - Туры в Китай",
    "description": "Авторские туры по Китаю от турагентства Максимум Тур. Индивидуальные и групповые туры в Пекин, Шанхай, Гуанчжоу и другие города Китая.",
    "touristType": [
      "Индивидуальные туристы",
      "Групповые туры",
      "Семейный отдых"
    ],
    "itinerary": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Пекин - Великая Китайская стена"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Шанхай - современный мегаполис"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Гуанчжоу - шопинг и культура"
        }
      ]
    }
  };

  return (
    <PageContainer>
      <SEO 
        title="Туры в Китай из Владивостока | Максимум Тур - Путешествия в КНР"
        description="Авторские туры по Китаю от турагентства Максимум Тур. Индивидуальные и групповые туры в Пекин, Шанхай, Гуанчжоу. Консультации экспертов по Китаю."
        keywords="туры в Китай, Китай путевки, Пекин, Шанхай, Гуанчжоу, путешествия в Китай, виза в Китай, Максимум Тур"
        type="website"
        structuredData={structuredData}
      />
      <Menu />
      <Header />
      <PageHeader />
      <TitleSection>
        <TitleContainer>
          <MainTitle>Наши туры по Китаю</MainTitle>
        </TitleContainer>
      </TitleSection>
      <ChinaToursPage />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default ChinaTours;